<template>
  <div>
    <v-col cols="12" style="text-align: left">
      <v-radio-group v-model="selected" label="Export Task(s) By" row>
        <v-radio
          label="Selected Task(s)"
          :value="taskSelected.length"
          v-if="taskSelected.length > 0"
        ></v-radio>
        <v-radio label="Selected Task(s)" v-else disabled></v-radio>
        <v-radio
          label="By Filter"
          value="MatchingFilters"
          v-if="checkFilter"
        ></v-radio>
        <v-radio
          label="By Filter"
          value="MatchingFilters"
          v-else
          disabled
        ></v-radio>
      </v-radio-group>
      Filter Selected:
      <div>Designer: {{ filterData.designer_username }}</div>
      <div>Status: {{ filterData.status }}</div>
    </v-col>

    <v-col cols="12">
      <template v-if="selected != null">
        <v-btn
          color="success"
          @click="
            loader = 'loading';
            exportData();
          "
          :loading="loading"
          :disabled="loading"
        >
          Export Data
          <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>mdi-loading</v-icon>
            </span>
          </template>
        </v-btn>
      </template>
      <v-btn color="success" v-else disabled>Export Data</v-btn>
      &nbsp;

      <v-btn
        class="white--text"
        color="warning"
        @click="cancelData"
        v-if="loader != 'loading'"
      >
        Cancel <v-icon right dark>mdi-window-close</v-icon>
      </v-btn>
      <v-btn class="white--text" color="warning" disabled v-else>
        Cancel <v-icon right dark>mdi-window-close</v-icon>
      </v-btn>
    </v-col>
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  data: () => ({
    loader: null,
    loading: false,
    selected: null,
    checkFilter: null,
  }),
  props: {
    taskSelected: Array,
    filterData: Object,
  },
  methods: {
    cancelData() {
      this.$root.$refs.task.turnOffDialog();
    },
    async exportData() {
      console.log("loader: ", this.loader);
      const l = this.loader;
      this[l] = !this[l];

      var data = {
        export: this.selected,
        task_ids: [],
        filters: {
          designer: "",
          status: "",
        },
      };

      if (data.export == "MatchingFilters") {
        data.filters["designer"] = this.filterData.designer_username;
        data.filters["status"] = this.filterData.status;
      } else if (data.export == this.taskSelected.length) {
        for (const i of this.taskSelected) {
          data.task_ids.push(i._id);
        }
      }

      console.log(data);

      var currentSession = await this.$root.$refs.App.currentSession(
        "task-export"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await fetch(window.domain + "tasks/export-tasks", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => console.log(data));
        this.$root.$refs.task.showAlert("export");
        //console.log('ABCD')
      } else {
        console.log("currentSession task-export-undefined: ", currentSession);
      }

      this[l] = false;
      this.loader = null;
    },
  },
  async mounted() {
    console.log("taskSelected: ", this.taskSelected);
    console.log("filterData: ", this.filterData);

    //console.log(this.filterData.designer)
    if (
      this.filterData.designer_username != "" ||
      this.filterData.status != ""
    ) {
      this.checkFilter = true;
      console.log(this.checkFilter);
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      var currentSession;
      try {
        currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
        console.log("task-assigned currentSession: ", currentSession);
      } catch (error) {
        console.log("task-assigned error: ", error);
      }
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>